"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70536],{

/***/ 22613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48761);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 14px);\n\n  .ant-slider-rail {\n    display: none;\n  }\n\n  .ant-slider-handle {\n    border: solid 2px ",
        ";\n  }\n\n  :hover .ant-slider-handle,\n  .ant-slider-handle:hover {\n    border-color: ",
        " !important;\n  }\n\n  .ant-slider-track {\n    height: 1px;\n    background-color: ",
        ";\n  }\n\n  :hover .ant-slider-track {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b8d003df-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary));


/***/ }),

/***/ 70536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TradingModal_OrderPlacedModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
;// CONCATENATED MODULE: ./src/global/Icons/ShareSvg.tsx

var ShareSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_7968_43563)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.25 10V14.6666C5.25 14.976 5.37292 15.2728 5.59171 15.4916C5.8105 15.7104 6.10724 15.8333 6.41666 15.8333H13.4166C13.726 15.8333 14.0228 15.7104 14.2415 15.4916C14.4603 15.2728 14.5833 14.976 14.5833 14.6666V10",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.2501 6.49982L9.91681 4.1665L7.5835 6.49982",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.91663 4.1665V11.7498",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7968_43563",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0.25)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ShareSvg = (ShareSvg);

// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeShareTracker.ts
var shareTradeShareTracker = __webpack_require__(56371);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(34400);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
;// CONCATENATED MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx





















var OrderPlacedModal = function(param) {
    var visible = param.visible, onSubmit = param.onSubmit, onReturnToTransaction = param.onReturnToTransaction, onCloseModal = param.onCloseModal, orderType = param.orderType, symbol = param.symbol, _returnTransactionLabel = param.returnTransactionLabel, returnTransactionLabel = _returnTransactionLabel === void 0 ? "Return to Orderbook" : _returnTransactionLabel;
    var pathname = (0,router.useRouter)().pathname;
    var isChartbit = pathname.includes("/chartbit");
    var isAmend = (0,react.useMemo)(function() {
        return orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    }, [
        orderType
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.orderType,
            s.resetShareTradeModal
        ];
    }, shallow/* default */.Z), 2), shareOrderType = ref[0], resetShareTradeModal = ref[1];
    var isShowShareButton = (0,react.useMemo)(function() {
        return !isAmend && [
            transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder,
            transaction/* SellOrderType.LimitOrder */.qK.LimitOrder
        ].includes(shareOrderType);
    }, [
        isAmend,
        shareOrderType
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.isVisible,
            s.setIsVisible,
            s.setSharedUsers
        ];
    }, shallow/* default */.Z), 3), isShareTradeVisible = ref1[0], setIsShareTradeVisible = ref1[1], setSharedUsers = ref1[2];
    var isOrderModalVisible = (0,react.useMemo)(function() {
        return visible && !isShareTradeVisible;
    }, [
        visible,
        isShareTradeVisible
    ]);
    var handleSubmit = function() {
        resetShareTradeModal();
        setSharedUsers({});
        if (isChartbit) onCloseModal();
        if (!isChartbit) onSubmit();
    };
    var handleShareTradeClick = function() {
        setIsShareTradeVisible(true);
        (0,shareTradeShareTracker/* trackOrderShareSelected */.M1)(orderType, symbol);
    };
    (0,react.useEffect)(function() {
        // don't track if the modal is visible and it is a bond transaction
        if (!visible || orderType === trading/* ORDER_TYPE.BOND */.Jm.BOND) {
            return;
        }
        if (orderType) {
            (0,securities/* clevertapOrderReceived */.dQ)({
                orderType: orderType
            });
            (0,autoOrder/* trackAutoBuyOrderReceivedView */.Bi)();
        }
    }, [
        visible
    ]);
    (0,useKeyPress/* default */.Z)([
        "Enter"
    ], function() {
        if (isOrderModalVisible) handleSubmit();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: isOrderModalVisible,
        width: "420px",
        onCancel: onCloseModal,
        centered: true,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/modal-close.svg"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                align: "center",
                padding: "40px 32px 20px 32px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/preview-order-sent.svg",
                        alt: "order-sent",
                        style: {
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "18px",
                        family: "bold",
                        children: "Order Sent"
                    }),
                    isShowShareButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justify: "center",
                        margin: "16px 0 0 0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ShareTradeButton */.Ae, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: Icons_ShareSvg
                            }),
                            type: "borderless",
                            onClick: handleShareTradeClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                align: "inherit",
                                color: "inherit",
                                family: "bold",
                                size: "14px",
                                children: "Share Trade"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                padding: "20px",
                children: [
                    !isAmend && !isChartbit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onReturnToTransaction,
                        type: "default",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        margin: "0 8px 0 0",
                        style: {
                            borderColor: color/* default.downgray */.Z.downgray
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "inherit",
                            color: color/* default.primary */.Z.primary,
                            family: "bold",
                            size: "14px",
                            children: returnTransactionLabel
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleSubmit,
                        type: "primary",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        margin: "0 0 0 8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "inherit",
                            color: "inherit",
                            family: "bold",
                            size: "14px",
                            children: "Done"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TradingModal_OrderPlacedModal = (OrderPlacedModal);


/***/ }),

/***/ 76805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ FeeItem; },
/* harmony export */   "Ae": function() { return /* binding */ ShareTradeButton; },
/* harmony export */   "QX": function() { return /* binding */ ModalTabText; },
/* harmony export */   "Qi": function() { return /* binding */ InvestmentWrapper; },
/* harmony export */   "Rn": function() { return /* binding */ InputNumber; },
/* harmony export */   "VA": function() { return /* binding */ PreviewContainer; },
/* harmony export */   "VV": function() { return /* binding */ FreezeLayer; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "W_": function() { return /* binding */ ModalFormWrapper; },
/* harmony export */   "__": function() { return /* binding */ PreviewModalContainer; },
/* harmony export */   "a7": function() { return /* binding */ ModalTab; },
/* harmony export */   "hK": function() { return /* binding */ ModalLitContent; },
/* harmony export */   "iV": function() { return /* binding */ SwitchWrapper; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "md": function() { return /* binding */ TransactionModalContainer; },
/* harmony export */   "n5": function() { return /* binding */ FormWrapper; },
/* harmony export */   "ph": function() { return /* binding */ FormHeader; },
/* harmony export */   "s8": function() { return /* binding */ PreviewItem; },
/* harmony export */   "sg": function() { return /* binding */ OrderButton; },
/* harmony export */   "ww": function() { return /* binding */ PreviewItemRow; },
/* harmony export */   "yH": function() { return /* binding */ InvestmentDetail; }
/* harmony export */ });
/* unused harmony exports FormItemWrapper, Tag, Slider, OrderPlacedConfirmWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22613);
/* harmony import */ var _deprecated_ui_trading_InputNumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4377);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62974);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 480px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 6px 6px 0 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  .ant-modal-close {\n    top: 8px;\n  }\n\n  .ant-modal-close-icon {\n    svg {\n      width: 14px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 15px;\n\n  &.has-border {\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  align-items: center;\n  border-radius: 2px;\n  background: ",
        ";\n  color: ",
        ";\n  padding: 0 8px;\n  font-weight: bold;\n  min-height: 25px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n  background: ",
        ";\n  border-radius: 4px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n\n  .ant-input-number-input {\n    padding: 0px !important;\n  }\n\n  .ant-input-number-handler-wrap {\n    width: 0px !important;\n  }\n\n  .ant-input-number-handler-up {\n    border-left: 1px solid ",
        ";\n    left: ",
        ";\n  }\n\n  .ant-input-number-handler-down {\n    border-right: 1px solid ",
        ";\n    left: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: all 0.3s ease;\n  gap: 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div {\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 6px;\n    margin-right: 2px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 6px 12px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  gap: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #f5f6f7;\n  &:hover {\n    cursor: pointer;\n    background: #f5f6f7;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40%;\n  text-align: right;\n  padding-right: 30px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-track {\n    background-color: ",
        " !important;\n    height: 3px;\n    top: 5px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  background: ",
        "80;\n  height: 92%;\n  z-index: 100;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  width: 100%;\n  transform: translateY(100%);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  cursor: pointer;\n  margin: ",
        " -20px -10px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 4px;\n  height: 44px;\n\n  background: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n\n  &.ant-btn-secondary {\n    background-color: ",
        ";\n    border-color: ",
        ";\n  }\n\n  & p {\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 19px;\n    color: inherit;\n    text-align: inherit;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  height: 51px;\n  width: 50%;\n  border-radius: 3px 3px 0 0;\n  background: ",
        ";\n  border-bottom: ",
        ";\n\n  :first-child {\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  color: #00ab6b;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: #00ab6b;\n  }\n\n  & .anticon {\n    width: 20px;\n    height: 20px;\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -16px;\n  transform: translateY(100%);\n\n  & > button {\n    margin: 0px 8px;\n\n    :first-child { \n      margin-left: 0;\n    }\n\n    :last-child { \n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 0;\n  background-color: transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  \n  .container {\n    background-color: #fff;\n    border-radius: 4px;\n  \n    .info {\n      padding: 40px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n  \n      padding: 40px 0;\n      gap: 16px;\n    };\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}









var ModalFormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-0"
})(_templateObject());
var PreviewModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-1"
})(_templateObject1());
var TransactionModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    width: "auto",
    type: "transparent",
    centered: true
}).withConfig({
    componentId: "sc-f4de7892-2"
})(_templateObject2());
var FormHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var FormItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-4"
})(_templateObject4());
var Tag = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].nightRider */ .Z.nightRider, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_trading_InputNumber__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs({
    formatter: function(value) {
        return (0,utils_number__WEBPACK_IMPORTED_MODULE_8__/* .formatNumber */ .uf)(value.replace(/\D/g, ""), false);
    },
    parser: function(value) {
        return value.replace(/[, ]+/g, "").trim();
    }
}).withConfig({
    componentId: "sc-f4de7892-7"
})(_templateObject7(), function(props) {
    // @ts-expect-error
    if (props.isForTriggerPrice) return "63px !important";
    return "100px !important";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, // @ts-expect-error
function(param) {
    var isForTriggerPrice = param.isForTriggerPrice;
    if (isForTriggerPrice) return "-1px !important";
    return "0px !important";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, // @ts-expect-error
function(param) {
    var isForTriggerPrice = param.isForTriggerPrice;
    if (isForTriggerPrice) return "-91px !important";
    return "-130px !important";
});
var PreviewContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-8"
})(_templateObject8());
var PreviewItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "100%",
    justify: "space-between",
    align: "center",
    py: "3px"
}).withConfig({
    componentId: "sc-f4de7892-9"
})(_templateObject9());
var PreviewItemRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "center",
    align: "center",
    gap: "4px"
}).withConfig({
    componentId: "sc-f4de7892-10"
})(_templateObject10());
var InvestmentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f4de7892-11"
})(_templateObject11());
var InvestmentDetail = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    width: "100%"
}).withConfig({
    componentId: "sc-f4de7892-12"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var FeeItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "100%",
    align: "center",
    justify: "space-between",
    py: "2px"
}).withConfig({
    componentId: "sc-f4de7892-13"
})(_templateObject13());
var FormLabel = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.attrs */ .ZP.div.attrs({
    align: "right",
    pr: "30px"
}).withConfig({
    componentId: "sc-f4de7892-14"
})(_templateObject14());
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-15"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetorange */ .Z.sunsetorange);
var FreezeLayer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-16"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-17"
})(_templateObject17());
var SwitchWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center",
    height: "40px"
}).withConfig({
    componentId: "sc-f4de7892-18"
})(_templateObject18(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return(// @ts-expect-error
    props.isOverlimit ? "50px" : "25px");
});
var OrderButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-19"
})(_templateObject19(), function(param) {
    var disabled = param.disabled;
    if (disabled) return "#616161 !important";
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary;
}, function(param) {
    var disabled = param.disabled;
    if (disabled) return "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].lowgray */ .Z.lowgray, "!important");
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light;
}, function(param) {
    var disabled = param.disabled;
    if (disabled) return "#616161 !important";
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var ModalTab = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-20"
})(_templateObject20(), function(param) {
    var isActive = param.isActive;
    return isActive ? _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light : _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].component */ .Z.component;
}, function(param) {
    var isActive = param.isActive;
    return !isActive && "1px solid ".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var ModalTabText = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    family: "bold",
    size: "24px",
    height: "50px",
    align: "center"
}).withConfig({
    componentId: "sc-f4de7892-21"
})(_templateObject21());
var ShareTradeButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-22"
})(_templateObject22());
var OrderPlacedConfirmWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-23"
})(_templateObject23());
var ModalLitContent = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-24"
})(_templateObject24());



/***/ }),

/***/ 34400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyPress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyPress() {
    var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], callback = arguments.length > 1 ? arguments[1] : void 0;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    var pressedKeysRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        callbackRef.current = callback;
    });
    var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        pressedKeysRef.current.add(event.key);
        // Check if all keys in the combination are pressed
        if (keys.every(function(key) {
            return pressedKeysRef.current.has(key);
        })) {
            callbackRef.current();
        }
    }, [
        keys
    ]);
    var handleKeyUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        pressedKeysRef.current.delete(event.key);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [
        handleKeyDown,
        handleKeyUp
    ]);
};


/***/ })

}]);